import {RedirectRoute, Route} from "../classes/RouteTypes";

export default [
    new RedirectRoute({path: '/', name: 'index', redirect: {name: 'login'}})
];
